import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/varietyShows";

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback(
    (index: number) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrentSlide(index);
      setTimeout(() => setIsTransitioning(false), 600);
    },
    [isTransitioning]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide, goToSlide]);

  const slide = heroSlides[currentSlide];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700 ease-in-out"
        style={{ backgroundImage: `url(${slide.imageUrl})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 w-full">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-10 md:pb-16">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              {slide.category}
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3 leading-tight">
              {slide.title}
            </h2>
            <p className="text-sm md:text-base text-background-200/90 mb-6 leading-relaxed max-w-lg">
              {slide.subtitle}
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              <Link
                to={`/article/${slide.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-fill w-4 h-4 flex items-center justify-center"></i>
                立即观看
              </Link>
              <Link
                to={`/category/zhenrenxiu`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                更多推荐
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-10 right-4 md:right-6 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? "bg-primary-500 w-6"
                : "bg-background-50/50 hover:bg-background-50/80"
            }`}
            aria-label={`切换到第${index + 1}张幻灯片`}
          ></button>
        ))}
      </div>

      <button
        onClick={() =>
          goToSlide(
            (currentSlide - 1 + heroSlides.length) % heroSlides.length
          )
        }
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 backdrop-blur-sm text-background-50 transition-all cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={() => goToSlide((currentSlide + 1) % heroSlides.length)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/40 backdrop-blur-sm text-background-50 transition-all cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>
    </section>
  );
}